/* unplugin-vue-components disabled */import { render } from "./Tree.vue?vue&type=template&id=8d6a5c74&scoped=true"
import script from "./Tree.vue?vue&type=script&lang=js"
export * from "./Tree.vue?vue&type=script&lang=js"

import "./Tree.vue?vue&type=style&index=0&id=8d6a5c74&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d6a5c74"]])

export default __exports__